export default __webpack_public_path__ + "static/media/anpassungen.ee8f196d.jpg";